import React, { useContext } from "react"
import { GlobalContext } from "../context/GlobalState"
import TokenGrid from './TokenGrid'

export default function Portfolio({ token }) {
  const { 
    portfolio 
  } = useContext(GlobalContext);

  return (
    <div className="token-page">
      <div className="container">
        <div className="header">
          <h1 className="heading">Portfolio</h1>
          <span className="count">
            ({portfolio.length} {portfolio.length === 1 ? "Token" : "tokens"})
          </span>
        </div>
        {portfolio.length > 0 ? (
          <div className="token-grid">
            {portfolio.map((token) => (
              <TokenGrid token={token} key={token.symbol} type="portfolio" />
            ))}
          </div>
        ) : (
          <h2 className="no-tokens">No tokens in your portfolio! HODL! </h2>
        )}
      </div>
    </div>
  )
}